<template>
    <div>
        <el-card class="box-card">
            <div style="margin-left:20px;margin-right:20px">
                <div style="height:32px">
                    <div style="float:left">
                        <el-button type="success" @click="getExl" icon="el-icon-download" size="small" plain>导出结果</el-button>
                        <el-button type="danger" :loading="loadingExl"  @click="importExcel" icon="el-icon-upload2" size="small" plain>降权订单检索</el-button>
                        <el-button type="danger" :loading="loadingExl"  @click="importTxt" icon="el-icon-upload2" size="small" plain>降权订单检索(txt)</el-button>
                        <input type="file"  ref="uploadExcel" v-show="false" accept=".xls,.xlsx" @change="readExcel">
                        <input type="file"  ref="uploadTxt" v-show="false" accept=".txt" @change="readTxt">
                          <!-- <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button> -->
                    </div>
                   <div style="float:right">
                        <el-input
                        size="small"
                        style="width:350px"
                        placeholder="用户手机号/任务编号/订单编号/买手账号/店铺名称"
                        v-model="queryModel.queryTxt"
                        @keydown.enter.native="query"
                        clearable>
                        </el-input>
                        <el-select size="small" style="margin-left:20px;width:120px" v-model="queryModel.status" placeholder="状态" clearable>
                            <el-option label="待确认" :value="99"></el-option>
                            <el-option label="搜索" :value="1"></el-option>
                            <el-option label="货比" :value="2"></el-option>
                            <el-option label="找到商品" :value="3"></el-option>
                            <el-option label="浏览详情" :value="4"></el-option>
                            <el-option label="收藏关注" :value="5"></el-option>
                            <el-option label="选择规格" :value="6"></el-option>
                            <el-option label="提交订单" :value="7"></el-option>
                            <el-option label="等待打款" :value="8"></el-option>
                            <el-option label="完成支付" :value="9"></el-option>
                            <el-option label="等待审核" :value="10"></el-option>
                            <el-option label="已完成" :value="11"></el-option>
                            <el-option label="已取消" :value="12"></el-option>
                        </el-select>

                        <el-date-picker
                        style="margin-left:20px;width:250px"
                        size="small"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-select size="small" style="margin-left:20px;width:100px"  filterable   v-model="queryModel.managerId" clearable placeholder="审核人">
                            <el-option v-for="v in outsiderList" :key="v.Id" :label="v.Name" :value="v.Id"> </el-option>
                        </el-select>

                        <el-select size="small" style="margin-left:20px;width:100px" v-model="queryModel.rebateMethod" placeholder="返款方式" clearable>
                            <el-option key="0" label="平台返款" value="0"> </el-option>
                            <el-option key="1" label="商家自反" value="1"> </el-option>
                        </el-select>

                        <el-select size="small" style="margin-left:20px;width:100px" v-model="queryModel.isOver" placeholder="全部" clearable>
                            <el-option label="进行中" value="1"></el-option>
                            <el-option label="已完成" value="2"></el-option>
                        </el-select>
                          <el-checkbox style="margin-left:10px" v-model="queryModel.isError">只看错误</el-checkbox>
                        <el-checkbox style="margin-left:0px" v-model="queryModel.isRefund">已退款</el-checkbox>
                        <el-button size="small" icon="el-icon-search" style="margin-left:20px" @click="queryAction" type="primary">搜索</el-button>
                   </div>
                </div>
                <div>
                    <el-divider content-position="left">订单列表</el-divider>
                    <el-pagination style="float:right;margin-top:-2px"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryModel.pIndex"
                    :page-sizes="[10, 20, 40, 60]"
                    :page-size="queryModel.pSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                    <el-table-column
                    width="100"
                                prop="DetailId"
                                label="DetailId">
                        </el-table-column>
                        <el-table-column
                        width="180px"
                            label="工单编号">
                            <template slot-scope="scope">
                                <el-link @click="showDetail(scope.row)" target="_blank" icon="el-icon-c-scale-to-original"  type="primary">{{scope.row.Code}}</el-link>
                               <br/>
                                <el-tag size="mini" v-if="scope.row.IsRefundOrder" style="margin-left:0px" effect="dark">退款单 </el-tag>

                            </template>
                        </el-table-column>
                                                <el-table-column
                        label="商品链接">
                            <template slot-scope="scope">
                                <el-link target="_blank"  :href="scope.row.Url" type="primary">点击跳转</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==6" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/dy.jpg">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="KeyWords"
                                label="商品搜索关键字">
                        </el-table-column>
                        <el-table-column
                                prop="Spec"
                                label="规格">
                        </el-table-column>
                        <el-table-column
                                label="买手提交单号">
                                <template slot-scope="scope">
                                    <el-link @click="updateOrderCode(scope.row)" type="primary">{{scope.row.OrderCode}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="AliTrademanager"
                                label="买手账号">
                        </el-table-column>
                        <el-table-column
                                width="120px"
                                label="商品单价">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.Price.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                width="120px"
                                label="买手垫付本金">
                                <template slot-scope="scope">
                                    <el-link v-if="scope.row.IsRefundOrder"   type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                    <el-link v-else @click="setAdvanceMoney(scope.row)" type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                width="80px"
                                label="任务佣金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.ActualCommission.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                width="100px"
                                label="第三方佣金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.Cost.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="Phone"
                                label="手机">
                        </el-table-column> 
                        <!-- <el-table-column
                        width="150"
                            label="微信">
                            <template slot-scope="scope" v-if="scope.row.WeChat">
                                <el-tooltip class="item" v-if="scope.row.ManagerWechatList.length==0" effect="dark" content="暂无微信所有者信息" placement="bottom">
                                    <el-link type="info">{{scope.row.WeChat}}</el-link>
                                </el-tooltip>
                                <el-tooltip v-else  class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p v-for="(v,i) in scope.row.ManagerWechatList" :key="i">
                                            <b>{{v.Name}}</b>
                                            ({{v.WeChat+":"+v.NickName}})
                                            <br/>
                                        </p>
                                    </div>
                                    <el-link type="info">{{scope.row.WeChat}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column> -->
                        <el-table-column
                                prop="Name"
                                label="审核人">
                        </el-table-column> 
                        <el-table-column
                                prop="OrderTime"
                                label="接单时间">
                        </el-table-column>                    
                        <el-table-column
                        label="状态">
                            <template  slot-scope="scope">
                                <el-tooltip v-if="scope.row.Status==12" class="item" effect="dark" :content="scope.row.CancelReason" placement="bottom">
                                    <el-tag effect="dark"  type="danger" size="mini">已取消</el-tag>
                                </el-tooltip>
                                <el-tag effect="dark" v-else-if="scope.row.Status==0" size="mini" >待确认</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==1" size="mini" >搜索</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==2" size="mini" >货比</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==3" size="mini" >找到商品</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==4" size="mini" >浏览详情</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==5" size="mini" >收藏关注</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==6" size="mini" >选择规格</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==7" size="mini" >提交订单</el-tag>

                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus<3" size="mini" >订单审核</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus==3" size="mini" >已打款</el-tag>

                                <el-tag effect="dark" v-else-if="scope.row.Status==9" size="mini" >完成支付</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==10" size="mini" >付款审核</el-tag>
                                <el-tag effect="dark" style="cursor:pointer" @click="undo(scope.row)" type="success" v-else-if="scope.row.Status==11" size="mini" >已完成</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column 
                        width="250px"
                            label="操作" >
                                <template slot="header">
                                        <el-tooltip class="item"  effect="dark" content="刷新任务" placement="bottom">
                                            <el-button size="mini" type="primary" @click="query" icon="el-icon-refresh" circle></el-button>
                                        </el-tooltip>
                                    </template>
                                <template v-if="scope.row.SwipeId>=0" slot-scope="scope">
                                    <el-tooltip  v-if="scope.row.Status>7" class="item" effect="dark" content="查看刷手上传的图片" placement="bottom">
                                        <el-button  size="mini" @click="seeImgs(scope.row)" icon="el-icon-view" circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip  v-if="scope.row.Status==8&&scope.row.PayStatus==1" class="item" effect="dark" content="审核通过，通过之后将会通知财务转款本金" placement="bottom">
                                        <el-button  size="mini" type="success" @click="payPrincipal(scope.row)" icon="el-icon-check" circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip  v-if="scope.row.Status==8&&scope.row.PayStatus==1" class="item" effect="dark" content="审核不通过，不通过之后将会回到上一步" placement="bottom">
                                        <el-button  size="mini" type="danger" @click="overPrincipal(scope.row)" icon="el-icon-close" circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip  v-if="scope.row.Status==10" class="item" effect="dark" content="审核，通过之后将会支付佣金给刷手" placement="bottom">
                                        <el-button  size="mini" type="success" @click="pass(scope.row)" icon="el-icon-check" circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip  v-if="scope.row.Status==10" class="item" effect="dark" content="审核不通过，不通过之后将会回到上一步" placement="bottom">
                                        <el-button  size="mini" type="danger" @click="over(scope.row)" icon="el-icon-close" circle></el-button>
                                    </el-tooltip>
                                    <el-button v-if="scope.row.Status==11&&manger.Role==1&&!scope.row.IsRefundOrder"   size="mini"   @click="operatingIncome(scope.row)" >退差额</el-button>

                                    <el-button v-if="scope.row.Status==11&&manger.Role==1&&!scope.row.Abnormal"   size="mini" type="danger" @click="abnormalOrder(scope.row)" >错误标记</el-button>
                                    <el-tooltip v-if="scope.row.Status==11&&manger.Role==1&&scope.row.Abnormal"  class="item" effect="dark" :content="scope.row.Abnormal" placement="left">
                                        <el-button   size="mini" type="danger"  >查看异常</el-button>
                                    </el-tooltip>

                                    <el-button v-if="scope.row.Status<11&&(manger.Role==1||manger.Role==2)"   size="mini" type="danger" @click="canelOrder(scope.row)" >取消</el-button>
                                    <el-button v-if="scope.row.Status<11&&manger.Role==1"   size="mini" type="success" @click="okOrder(scope.row)" >结佣</el-button>
                                </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-card>
                <el-drawer
        :modal="false"
        style="z-index:9999"
        title="任务审核"
        :visible.sync="overVisible">
            <el-form  style="padding:20px" :model="overModel"  :rules="orverRules" ref="overForm" label-width="170px">
                <el-form-item label="店铺：" >
                                            <span v-if="setRow.ShopType==1" >
                                                <div style="margin-left:5px;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                                    {{setRow.ShopName}}
                                                    </div>
                                            </span>
                                            <span v-else-if="setRow.ShopType==2" >
                                                <div style="margin-left:5px;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                                    {{setRow.ShopName}}
                                                </div>
                                            </span>
                                            <span  v-else>
                                                <div style="margin-left:5px;">
                                                    <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                                    {{setRow.ShopName}}
                                                </div>
                                            </span>
                </el-form-item>
                <el-form-item label="规格&单价&购买数量&垫付金额：">
                     <el-tag size="mini" >{{setRow.Spec}}</el-tag>
                     <el-tag size="mini" type="danger" effect="dark"  style="margin-left:20px">￥{{setRow.Price}}</el-tag>
                     <el-tag size="mini" effect="plain"  style="margin-left:20px">× {{setRow.BuyNum}}</el-tag>
                      <el-tag size="mini" type="" effect="dark"  style="margin-left:20px">￥{{setRow.AdvanceMoney}}</el-tag>
                </el-form-item>

                <el-form-item label="买手提交订单号：" prop="orderCode">
                    <el-input  placeholder="请输入买手提交订单号" v-model="overModel.orderCode"></el-input>
                </el-form-item>
                <el-form-item label="买手阿里旺旺：" prop="aliTrademanager">
                    <el-input placeholder="请输入买手阿里旺旺" v-model="overModel.aliTrademanager"></el-input>
                </el-form-item>
                <el-form-item label="买手实际垫付金额：" prop="advanceMoney">
                    <el-input :disabled="setRow.IsRefundOrder" placeholder="请输入买手实际垫付金额" v-model="overModel.advanceMoney"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align:center">
                <el-button @click="overVisible = false">取 消</el-button>
                <el-button :loading="isLoadingPass" type="primary" @click="submitOver">确 定</el-button>
            </div>
                        
        </el-drawer>
                        <el-image-viewer 
                style="z-index:999;text-align:left"
                v-if="overVisible"  
                :url-list="[setRow.ReviewImg]" />

        <el-dialog title="取消订单" :visible.sync="canelVisible" width="400px">
            <el-form  :model="canelModel"    ref="" label-width="90px">
                <el-form-item label="原因分类：" >
                      <el-radio-group v-model="canelModel.exceptionType">
                        <el-radio :label="3">联系不上买手</el-radio>
                        <el-radio :label="4">不愿意垫付</el-radio>
                        <el-radio :label="7">不想做了</el-radio>
                        <el-radio :label="9">其它</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="取消原因：">
                    <el-input v-model="canelModel.reason" placeholder="请输入取消原因"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="canelVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitCanelOrder">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="撤销订单" :visible.sync="undoVisible" width="400px">
            <el-form  :model="canelModel"     label-width="90px">
                <!-- <el-form-item label="原因分类：" >
                    <el-radio-group v-model="canelModel.exceptionType">
                        <el-radio :label="6">退本退佣</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item label="">
                      <el-checkbox v-model="canelModel.isDeduction">是否扣刷手佣金</el-checkbox>
                </el-form-item>
                
                <el-form-item label="备注：">
                    <el-input v-model="canelModel.reason" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="undoVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUndoOrder">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="退差额(花呗/信用卡/红包)" :visible.sync="operatingIncomeVisible" width="400px">
            <el-form :model="operatingIncomeModel"  :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="补商家金额：" prop="memberMoney">
                    <el-input placeholder="请输入补商家金额" v-model="operatingIncomeModel.memberMoney"></el-input>
                </el-form-item>
                <el-form-item label="扣会员金额：" prop="swipeMoney">
                    <el-input placeholder="请输入扣会员金额" v-model="operatingIncomeModel.swipeMoney"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="description">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入备注"
                        v-model="operatingIncomeModel.description">
                    </el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="operatingIncomeVisible = false">取 消</el-button>
                <el-button type="primary" @click="operatingIncomeSumbit">确 定</el-button>
            </div>
        </el-dialog>
        <el-drawer
        title="降权订单检索"
        size="80%"
        :with-header="false"
        :visible.sync="jiangOrder.visible"
        direction="ltr">
          <el-card class="box-card" style="height:100%">
            <div slot="header" class="clearfix">
                <el-button type="success" @click="getJiangExl" icon="el-icon-download" size="small" plain>导出结果</el-button>

                <span style="margin-left:50px"><el-tag size="small"  effect="dark">单数：{{jiangOrder.num}}</el-tag></span>
                <span style="margin-left:50px"><el-tag size="small"  effect="dark">佣金：￥{{jiangOrder.cost.toFixed(2)}}</el-tag></span>
                <!-- <el-button style="float: right; padding: 3px 0;"  circle></el-button> -->
                  <el-button @click="jiangOrder.visible=false" size="small" type="danger" icon="el-icon-close" style="float:right" circle></el-button>

            </div>
                <el-table
                :data="jiangOrder.list"
                style="width: 100%;height:100%">
                <el-table-column
                    width="100"
                                prop="DetailId"
                                label="DetailId">
                        </el-table-column>
                        <el-table-column
                        width="180px"
                            label="工单编号">
                            <template slot-scope="scope">
                                <el-link @click="showDetail(scope.row)" target="_blank" icon="el-icon-c-scale-to-original"  type="primary">{{scope.row.Code}}</el-link>
                               <br/>
                                <el-tag size="mini" v-if="scope.row.IsRefundOrder" style="margin-left:0px" effect="dark">退款单 </el-tag>

                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>

                        <el-table-column
                                label="买手提交单号">
                                <template slot-scope="scope">
                                    <el-link @click="updateOrderCode(scope.row)" type="primary">{{scope.row.OrderCode}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="AliTrademanager"
                                label="买手账号">
                        </el-table-column>
                        <el-table-column
                                width="120px"
                                label="买手垫付本金">
                                <template slot-scope="scope">
                                    <el-link v-if="scope.row.IsRefundOrder"   type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                    <el-link v-else @click="setAdvanceMoney(scope.row)" type="danger">￥{{scope.row.AdvanceMoney.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                width="80px"
                                label="任务佣金">
                                <template slot-scope="scope">
                                    <el-link type="danger">￥{{scope.row.ActualCommission.toFixed(2)}}</el-link>
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="Phone"
                                label="手机">
                        </el-table-column> 
                        <el-table-column
                        width="70"
                                prop="Name"
                                label="审核人">
                        </el-table-column> 
                        <el-table-column
                        width="160"
                                prop="OrderTime"
                                label="接单时间">
                        </el-table-column>                    
                        <el-table-column
                        width="70"
                        label="状态">
                            <template  slot-scope="scope">
                                <el-tooltip v-if="scope.row.Status==12" class="item" effect="dark" :content="scope.row.CancelReason" placement="bottom">
                                    <el-tag effect="dark"  type="danger" size="mini">已取消</el-tag>
                                </el-tooltip>
                                <el-tag effect="dark" v-else-if="scope.row.Status==0" size="mini" >待确认</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==1" size="mini" >搜索</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==2" size="mini" >货比</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==3" size="mini" >找到商品</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==4" size="mini" >浏览详情</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==5" size="mini" >收藏关注</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==6" size="mini" >选择规格</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==7" size="mini" >提交订单</el-tag>

                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus<3" size="mini" >订单审核</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==8&&scope.row.PayStatus==3" size="mini" >已打款</el-tag>

                                <el-tag effect="dark" v-else-if="scope.row.Status==9" size="mini" >完成支付</el-tag>
                                <el-tag effect="dark" v-else-if="scope.row.Status==10" size="mini" >付款审核</el-tag>
                                <el-tag effect="dark" style="cursor:pointer" @click="undo(scope.row)" type="success" v-else-if="scope.row.Status==11" size="mini" >已完成</el-tag>
                            </template>
                        </el-table-column>
                </el-table>
        </el-card>
        </el-drawer>
        <el-image-viewer 
                style="z-index:999999"
                v-if="showViewer" 
                :on-close="closeImg" 
                :url-list="imgs" />
    </div>
</template>
<script>
const validateAcquaintance = (rule, value, callback) => {
  if (value < 1 || value > 200000) {
    callback(new Error('金额必须在 1 至 200000 之间'))
  } else {
    callback()
  }
}
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import XLSX from 'xlsx'

import {orderGetJiangQuanOrderExl, orderGetJiangQuanOrder, orderOperatingIncome,orderSetOrderAbnormal,orderUpdateOrderCode, outsiderGetSel,orderCancelOrder,orderPass,orderOverPrincipal,orderGetImgs,orderPayPrincipal,
orderOver,taskGetOrder,uri,orderUndo,orderOkOrder,orderSetAdvanceMoney} from '@/request.js'
export default {
  name: 'App',
    props:{
        manger:{
            type:Object,
            required: true
        }
    },
  components: {
      ElImageViewer
  },
  data() {
    return {
        loadingExl:false,
        rules: {
                memberMoney: [
                    { required: true, message: '请填写退给商家的金额', trigger: 'blur' },
                ],
                swipeMoney: [
                    { required: true, message: '请填写收取会员的金额', trigger: 'blur' },
                ],
                description: [
                    { required: true, message: '请填写备注', trigger: 'blur' },
                    { min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur' }
                ],
 
        },
        operatingIncomeVisible:false,
        operatingIncomeModel:{
            memberMoney:0,
            swipeMoney:0,
            orderId:0,
            description:"",
        },
        canelModel:{
            id:0,
            reason:"",
            exceptionType:0,
            isDeduction:false,
        },
        isLoadingPass:false,
        undoVisible:false,
        canelVisible:false,
        showViewer:false,
        bodyHeight:0,
        total:0,
        queryModel:{
            queryTxt:"",
            shopId:"",
            status:"",
            rebateMethod:"",
            pIndex:1,
            pSize:10,
            createTimes:[],
            isOver:"",
            managerId:"",
            isError:false,
            isRefund:false,
        },
        tableData:[],
        imgs:[],
        overVisible:false,
        overModel:{orderCode:"",aliTrademanager:"",advanceMoney:0,orderId:0},
        orverRules: {
            orderCode: [
                { required: true, message: '请填写买手提交订单号：', trigger: 'blur' },
                { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
            ],
            aliTrademanager: [
                { required: true, message: '请填写买手阿里旺旺：', trigger: 'blur' },
                { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
            ],
            advanceMoney: [
                { required: true, message: '请填写买手实际垫付金额：',trigger: 'blur'},
                { validator: validateAcquaintance, trigger: 'blur'}            
            ],
        },
        setRow:{},
        isLoading:false,
        outsiderList:[],
        jiangOrder:{num:0,cost:0,visible:false},
        jiangOrderCodeList:[],
    };
  },
  watch:{
  },
  created() {
        var date=new Date();
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.bodyHeight=document.documentElement.clientHeight-129;
  },
  mounted() {
      outsiderGetSel({type:2},(res)=>{
            this.outsiderList=res.Result;
        });
       let taskcode = this.$route.query.taskcode;
       let queryTxt = this.$route.query.queryTxt;
       if(taskcode){
           this.queryModel.queryTxt=taskcode;
       }
       if(queryTxt){
           this.queryModel.queryTxt=queryTxt;
       }
      this.query();
  },
   methods:{
       getJiangExl(){
           orderGetJiangQuanOrderExl({orderCodeJson:JSON.stringify(this.jiangOrderCodeList)},(res)=>{
            let blob = new Blob([res], {
                type: "application/vnd.ms-excel"
            }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
            let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
            // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
            let a = document.createElement("a");
            a.href = url;
            a.download = "降权订单.xlsx";
            a.click();
            // 5.释放这个临时的对象url
            window.URL.revokeObjectURL(url);
            })
       },
        readExcel(e) {
            const files = e.target.files;
            if (files.length <= 0) {
                //如果没有文件名
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = ev => {
                try {
                    this.loadingExl=true;
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    });
                    const wsname = workbook.SheetNames[0]; //取第一张表
                    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //获取到XLSX表格中的数据,并生成json格式的数据类型
                    let arr = [];
                    ws.forEach((value, index, ws) => {
                        arr.push(ws[index]["订单号"] + "");
                    })
                    orderGetJiangQuanOrder({orderCodeJson:JSON.stringify(arr)},(res)=>{
                        this.jiangOrderCodeList=arr;
                        this.jiangOrder.list=res.Result.List;
                        this.jiangOrder.cost=res.Result.Cost;
                        this.jiangOrder.num=res.Result.Num;
                        this.jiangOrder.visible=true;
                        this.loadingExl=false;
                    })
                } catch (e) {
                    this.$message({
                        message: '填写数据错误或模板错误，请核对',
                        type: 'warning'
                    });
                    this.loadingExl=false;
                    return false;
                }
            };
            fileReader.readAsBinaryString(files[0]);
        },
        readTxt(e) {
            this.files = (e.target || e.srcElement).files;  //获取"input-file"的FileList对象
				if (!this.files || !this.files.length)
					return;
				for (let i = 0, len = this.files.length; i < len; i++)
					this.read(this.files[i]);
                    
        },
        importExcel(){
           this.$refs.uploadExcel.click();
        },
        importTxt(){
           this.$refs.uploadTxt.click();
        },
        read(f) {
			let rd = new FileReader();
			rd.onload = e => {  //this.readAsArrayBuffer函数内，会回调this.onload函数。在这里处理结果
                var content = e.currentTarget.result;
                let arr = [];
                for (let i = 0, len = content.length; i < len; i++){
                    arr.push(content.substr(i,19));
                    i+=18;
                }
                orderGetJiangQuanOrder({orderCodeJson:JSON.stringify(arr)},(res)=>{
                        this.jiangOrderCodeList=arr;
                        this.jiangOrder.list=res.Result.List;
                        this.jiangOrder.cost=res.Result.Cost;
                        this.jiangOrder.num=res.Result.Num;
                        this.jiangOrder.visible=true;
                        this.loadingExl=false;
                    })
			};
			rd.readAsBinaryString(f);
		},
        operatingIncomeSumbit(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    orderOperatingIncome(this.operatingIncomeModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.operatingIncomeVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    return false;
                }
            });
       },
       operatingIncome(scope){
           var val="订单"+scope.OrderCode+"使用XX，补/扣差额";
           this.operatingIncomeModel={
                memberMoney:0,
                swipeMoney:0,
                orderId:scope.Id,
                description:val,
           };
           this.operatingIncomeVisible=true;
       },
       setAdvanceMoney(scope){
            if(this.manger.Role!=1){
                this.$message({
                    message: '没有操作权限',
                    type: 'warning'
                });
                return;
            }
            this.$prompt('请填写实际垫付金额', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputValue:scope.AdvanceMoney,
                inputErrorMessage: '垫付金额不能为空'
                }).then(({ value }) => {
                    var advanceMoney= parseFloat(value);
                    orderSetAdvanceMoney({
                        orderId:scope.Id,
                        advanceMoney: advanceMoney
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            scope.AdvanceMoney=advanceMoney;
                            scope.Cost=res.Result;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
      
                });
       },
       abnormalOrder(scope){
                this.$prompt('请描述出现的错误', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputValue:"垫付金额与实际有出入",
                inputErrorMessage: '错误描述不能为空'
                }).then(({ value }) => {
                    orderSetOrderAbnormal({
                        orderId:scope.Id,
                        abnormal: value
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '标记成功',
                                type: 'success'
                            });
                            scope.Abnormal=value;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
      
                });
       },
       okOrder(scope){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                orderOkOrder({orderId:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=11;
                        }else{
                            this.$message.error(res.Message);
                        }
                })
            }).catch(() => {
       
            });
       },
        updateOrderCode(scope){
                this.$prompt('请输入新的买手提交单号', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputValue:scope.OrderCode,
                inputErrorMessage: '买手提交单号不能为空'
                }).then(({ value }) => {
                    orderUpdateOrderCode({
                        orderId:scope.Id,
                        orderCode: value
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            scope.OrderCode=value;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
                });
        },
        submitUndoOrder(){
            if(this.canelModel.exceptionType==0){
                this.$message({
                    message: '请选择撤销类别',
                    type: 'warning'
                });
                return;
            }
            orderUndo({id:this.canelModel.id,reason:this.canelModel.reason,exceptionType:this.canelModel.exceptionType,isDeduction:this.canelModel.isDeduction},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '订单取消成功',
                        type: 'success'
                    });
                    this.setRow.Status=12;
                    this.setRow.CancelReason=this.canelModel.reason;
                    this.undoVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
         undo(scope){
            this.canelModel={
               id:scope.Id,
               reason:"",
               exceptionType:6,
               isDeduction:false,
           };
           this.undoVisible=true;
           this.setRow=scope;
        },
        submitCanelOrder(){
            if(this.canelModel.reason==""||this.canelModel.exceptionType==0){
                this.$message({
                    message: '请填写取消原因，选择取消类别',
                    type: 'warning'
                });
                return;
            }
            orderCancelOrder({id:this.canelModel.id,reason:this.canelModel.reason,exceptionType:this.canelModel.exceptionType},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '订单取消成功',
                        type: 'success'
                    });
                    this.setRow.Status=12;
                    this.setRow.CancelReason=this.canelModel.reason;
                    this.canelVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
       canelOrder(scope){
           this.canelModel={
               id:scope.Id,
               reason:"",
               exceptionType:0,
           };
           this.canelVisible=true;
           this.setRow=scope;
       },
       over(scope){
            this.$prompt('请输入不通过原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '请输入不通过原因'
            }).then(({ value }) => {
                orderOver({orderId:scope.Id,remark:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.Status=9;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
       },
       closeImg(){
            this.showViewer=false;
        },
        payPrincipal(scope){
            console.log(scope);
            this.$prompt('请确认刷手提交订单付款金额', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
            inputValue:scope.AdvanceMoney,
            inputErrorMessage: '请填写正确的付款金额'
            }).then(({ value }) => {
                orderPayPrincipal({orderId:scope.Id,advanceMoney:parseFloat(value)},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        if(scope.IsAdvance){
                            scope.PayStatus=3;
                            scope.Status=9;
                            scope.AdvanceMoney=parseFloat(value);
                        }else{
                            scope.PayStatus=2;
                            scope.AdvanceMoney=parseFloat(value);
                        }
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        overPrincipal(scope){
            this.$prompt('请输入不通过原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '请输入不通过原因'
            }).then(({ value }) => {
                orderOverPrincipal({orderId:scope.Id,remark:value},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.Status=7;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        pass(scope){
            this.overVisible=true;
            this.overModel.aliTrademanager=scope.AliTrademanager;
            this.overModel.orderCode=scope.OrderCode;
            this.overModel.advanceMoney=scope.AdvanceMoney;
            this.overModel.orderId=scope.Id;
            this.setRow=scope;
        },
        submitOver(){
            this.$refs["overForm"].validate((valid) => {
                if (valid) {
                    this.isLoadingPass=true;
                    orderPass(this.overModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.setRow.Status=res.Result.Status;
                            this.setRow.AliTrademanager=res.Result.AliTrademanager;
                            this.setRow.OrderCode=res.Result.OrderCode;
                            this.setRow.ActualCommission=res.Result.ActualCommission;
                            this.setRow.AdvanceMoney=res.Result.AdvanceMoney;
                            this.overModel={orderCode:"",aliTrademanager:"",advanceMoney:0,orderId:0};
                            this.overVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                        this.isLoadingPass=false;
                    });
                } else {
                    return false;
                }
            });
        },
       seeImgs(scope){
           orderGetImgs({orderId:scope.Id},(res)=>{
               this.imgs=res.Result;
               this.showViewer=true;
           });
       },

       queryAction(){
           this.queryModel.pIndex=1;
           this.query();
       },
       getExl(){
           let over=this.queryModel.isOver==""?0:parseInt(this.queryModel.isOver);
           window.open(uri+"/TaskBatch/GetOrderExl?isRefund="+this.queryModel.isRefund+"&isError="+this.queryModel.isError+
           "&isOver="+over+
           "&managerId="+(this.queryModel.managerId==""?0:parseInt(this.queryModel.managerId))+
           "&queryTxt="+this.queryModel.queryTxt+"&status="+(this.queryModel.status==""?-1:parseInt(this.queryModel.status))+
           "&shopId="+(this.queryModel.shopId==""?0:parseInt(this.queryModel.shopId))+
           "&rebateMethod="+(this.queryModel.rebateMethod==""?99:parseInt(this.queryModel.rebateMethod))+
           "&createTimes="+(this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes))
           );
       },
       query(){
           this.isLoading=true;
           taskGetOrder({
               queryTxt:this.queryModel.queryTxt,
               status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
               shopId:this.queryModel.shopId==""?0:parseInt(this.queryModel.shopId),
               rebateMethod:this.queryModel.rebateMethod==""?99:parseInt(this.queryModel.rebateMethod),
               pIndex:this.queryModel.pIndex,
               pSize:this.queryModel.pSize,
               createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
               isOver:this.queryModel.isOver==""?0:parseInt(this.queryModel.isOver),
               managerId:this.queryModel.managerId==""?0:parseInt(this.queryModel.managerId),
               isError:this.queryModel.isError,
               isRefund:this.queryModel.isRefund,

           },(res)=>{
               this.tableData=res.Result;
               this.total=res.TotalCount;
               this.isLoading=false;
           })
       },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },
   },
}
</script>